import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { mcpCredentialsUrl, resolveMcpAuth } from './mcp-auth';

export default async function get_all_connected_mcp_api_call(active?: boolean) {
  const shopSlug = store.getState().user?.company?.shop_slug;
  const auth = resolveMcpAuth();

  // No active brand/shop selected → no connections to load. Return an empty
  // array (NOT false) so the consumer's processData can map over it safely.
  if (!shopSlug || shopSlug === '') return [];

  const requestInfo: RequestInfo = {
    url: `${mcpCredentialsUrl(auth, shopSlug)}${active ? '/active' : ''}`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: auth.authorization,
    },
  };

  const actionType = 'GET_ALL_CONNECTED_MCP_LIST';
  const customMsg = 'Connected MCP Data Loaded Successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;
  // Guard the deref: asyncHandler returns null/undefined on 401/network error.
  // Return [] (not false) so the consumer never crashes mapping the result.
  if (!response?.success) {
    return [];
  }
  if (res.actionType === actionType && response.success === true) {
    if (response.data === null) {
      return [];
    } else {
      const data = response?.data;

      //* Format the data to add manual credentials to the accounts list
      const formatted_data = data.map((item: any) => {
        const newItem = JSON.parse(JSON.stringify(item));

        if (newItem.credentials && newItem.accounts) {
          for (const key in newItem.credentials) {
            if (newItem.credentials.hasOwnProperty(key)) {
              const credentialValue = newItem.credentials[key];

              if (
                newItem.accounts.hasOwnProperty(key) &&
                Array.isArray(newItem.accounts[key])
              ) {
                const accountList = newItem.accounts[key];

                const isValuePresent = accountList.some(
                  (account: any) => account.OptionValue === credentialValue
                );

                if (!isValuePresent) {
                  accountList.push({
                    OptionName: credentialValue,
                    OptionValue: credentialValue,
                  });
                }
              }
            }
          }
        }
        return newItem;
      });
      return formatted_data;
    }
  }
}
